<template>
  <div class="carAccidentList">
    <QS-common-table
      class="mt16"
      :data="tableData"
      :columns="headColumn"
      :pagination="paginationData"
      :loading="loading.search"
      @change="paginationEvent"
      >
        <template slot-scope="scope" slot="col-id">
          <div
            :style="{ color: scope.row.id ? '#0059DC' : '#0059DC' }"
            @click="JumpDetails(scope.row)"
            style="cursor: pointer"
            v-if="judgePermission('vehicle_accident_list_detail')"
          >
            {{ scope.row.id }}
          </div>
          <div v-else>
            {{ scope.row.id }}
          </div>
        </template>
    </QS-common-table>
    <SettlementDialog
      :params="settlementParams"
      @paginationEvent="paginationEvent"
      v-model="showDialog"
    />
  </div>
</template>
<script>
import selectOption from '@/store/dict/selectOptionDict'
import { getAccidentList, accidentDestail } from '@/api/domain/carsService'
import SettlementDialog from './settlementDialog'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  components: {
    SettlementDialog,
  },
  data() {
    return {
      // 表格数据
      tableData: [],
      headColumn: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '事故ID',
          },
          type: 'manual',
        },
        {
          name: 'orderId',
          columnProps: {
            prop: 'orderId',
            label: '订单ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
          showColumnItem: !this.isCarDetail,

        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'carModelName',
          columnProps: {
            prop: 'carModelName',
            label: '车型',
          },
          showColumnItem: !this.isCarDetail,

        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户信息',
          },
        },
        {
          name: 'reportDate',
          columnProps: {
            prop: 'reportDate',
            label: '报案日',
          },
        },
        {
          name: 'accidentBlame',
          columnProps: {
            prop: 'accidentBlame',
            label: '事故责任',
          },
          getText: ({ row }) => selectOption.accidentResponsibilityDict[row.accidentBlame],
        },
        {
          name: 'claimState',
          columnProps: {
            prop: 'claimState',
            label: '出险状态',
          },
          getText: ({ row }) => selectOption.outInsuranceStatusDict[row.claimState],
        },
        {
          name: 'accidentStatus',
          columnProps: {
            prop: 'accidentStatus',
            label: '事故状态',
            width: 120,
          },
          getText: ({ row }) => selectOption.accidentStatusDict[row.accidentStatus],
        },
        {
          name: 'settlementStatus',
          columnProps: {
            prop: 'settlementStatus',
            label: '结算状态',
            width: 120,
          },
          getText: ({ row }) => selectOption.settlementForm[row.settlementStatus],
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'operate',
          columnProps: {
            prop: 'operate',
            label: '操作',
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []

            if (this.judgePermission('vehicle_accident_list_edit')) {
              result.push({
                name: 'edit', label: '编辑', action: () => this.JumpEdit(row),
              })
            }
            if (this.judgePermission('vehicle_accident_list_create_settlement') && row.accidentStatus === 3 && row.settlementStatus === null) {
              result.push({
                name: 'settlement', label: '发起结算', action: () => this.JumpSettlement(row),
              })
            }
            return result
          },
        },

      ],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      // 结算弹窗数据
      settlementParams: {
        carId: '',
        accidentId: '', // 事故ID
        remarks: '', // 备注
        plateNo: '', // 车牌号
        receivableAmount: '', // 应收金额
        receivableDate: '', // 应收日期
        customerType: '', // 付款方类型
        customerId: '', // 付款方
        content: 19, // 固定 故事费
        contentName: '事故费', // 收款内容
      },
      showDialog: false, // 结算弹窗
    }
  },
  props: {
    loading: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    // 判断是不是车辆详情
    isCarDetail: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /* 分页 */
    paginationEvent(payload) {
      const { pagination = null } = payload || {}
      if (pagination) {
        // eslint-disable-next-line vue/no-mutating-props
        this.params.pageSize = pagination.pageSize
        // eslint-disable-next-line vue/no-mutating-props
        this.params.pageNum = pagination.pageNum
      }
      this.getList(this.params)
    },
    /* 跳转详情 */
    JumpDetails(data) {
      const { id } = data
      this.$router.push({
        path: '/vehicle/accident/detail',
        query: { id },
      })
    },
    /* 跳转编辑 */
    JumpEdit(data) {
      const { id } = data
      const { scene } = this.$route.query
      const query = {
        id,
      }
      if (scene) {
        query.scene = scene
      }
      this.$router.push({
        path: '/vehicle/accident/edit',
        query,
      })
    },
    // 发起结算
    JumpSettlement(row) {
      const { id } = row
      accidentDestail({
        id,
      }).then((res) => {
        const { code, data } = res
        const { receivableAmount, plateNo, carId, customerName, customerId = '' } = data
        let customerType = ''
        if (code === 1) {
          if (customerId) {
            customerType = 2
          }
          this.settlementParams = Object.assign(this.settlementParams, { receivableAmount, plateNo, carId, customerId, customerType, customerName, accidentId: data.id })
          this.showDialog = true
        }
      })
    },
    /* 获取列表 */
    async getList(res) {
      // eslint-disable-next-line vue/no-mutating-props
      this.loading.search = true
      try {
        const { code, data } = await getAccidentList(res)
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.search = false
        if (code === 1) {
          this.tableData = data.items || []
          this.paginationData.total = data.totalNum
        }
      } catch {
      // eslint-disable-next-line vue/no-mutating-props
        this.loading.search = false
      }
    },
  },
  mounted() {
    // 车辆详情的事故页面直接请求接口，而车辆-事故管理不直接请求，而是外面组件调用
    if (this.isCarDetail) {
      this.getList(this.params)
    }
  },
  watch: {
    params: {
      handler(val) {
        this.paginationData = {
          pageSize: val.pageSize,
          pageNum: val.pageNum,
          total: this.paginationData.total,
          pageSizes: [10, 20, 30, 50],
        }
      },
      deep: true,
    },
  },
}
</script>
